import * as types from '../types';
import * as Commons from '../utils/Commons';
import { STRINGS } from '../utils/Strings';
import * as ServerOperations from '../utils/ServerOperations';
import { Alert } from 'react-native';

import loaderHandler from "../components/react-native-busy-indicator/LoaderHandler";

export const updateState = state => ({
    type: types.REGISTER_SECOND_UPDATE_STATE,
    payload: state
});

export const resetState = () => ({
    type: types.REGISTER_SECOND_RESET_STATE
});

export const checkIfUserExists = (self) => async (dispatch) => {
    const { mobile, email } = self.props;
    loaderHandler.showLoader(STRINGS.please_wait, self);
    let resp = await ServerOperations.checkIfUserExists("", "", mobile);
    if (resp.length > 0) {
        loaderHandler.hideLoader();
        Commons.toast(STRINGS.err_mobile_already_used, 'error');
        return true;
    }
    resp = await ServerOperations.checkIfUserExists("", email, "");
    if (resp.length > 0) {
        loaderHandler.hideLoader();
        Commons.toast(STRINGS.err_email_already_used, 'error');
        return true;
    }
    // loaderHandler.hideLoader();
    return false;
}

export const requestOTP = (self, mobile) => async (dispatch) => {
    loaderHandler.showLoader(STRINGS.please_wait, self);
    const resp = await ServerOperations.getRegisterationOTP(mobile);
    self.otpModal.open();
    loaderHandler.hideLoader();
    dispatch(updateState({ serverToken: resp.OTP, token: '' }));
    setTimeout(() => {
        self.otpTxt.focus();
    }, 1000);
};

export const registerUser = (self, user, isUpdate) => async dispatch => {
    loaderHandler.showLoader(STRINGS.please_wait, self);
    const response = await ServerOperations.registerUser(user, isUpdate);
    loaderHandler.hideLoader();
    if (response !== null) {
        if (response.ERROR === '') {
            dispatch({ type: types.REGISTER_SECOND_RESET_STATE });
            dispatch({ type: types.REGISTER_FIRST_RESET_STATE });
            await Commons.saveUserInfo(user);
        } else {
            Commons.okMsgAlert(response.ERROR);
        }
    } else {
        Commons.toast(STRINGS.offline);
    }

};

export const setupUserInfo = user => ({
    type: types.REGISTER_SECOND_SETUP_USER,
    payload: user
});
